import Image from "next/image";

import { cn } from "@/lib/utils";
import type { CaptionStyle } from "@/lib/caption-styles/content";

const CaptionStyleThumbnail = ({
  style,
  className,
  imageClassName,
  priority = false,
}: {
  style: Pick<CaptionStyle, "name" | "thumbnail" | "plate">;
  className?: string;
  imageClassName?: string;
  priority?: boolean;
}) => (
  <div
    className={cn(
      "relative flex w-full items-center justify-center overflow-hidden",
      style.plate === "light" ? "bg-[#F3F4F6]" : "bg-[#101828]",
      className,
    )}
  >
    <Image
      src={style.thumbnail}
      alt={`${style.name} caption style preview`}
      width={540}
      height={540}
      unoptimized
      priority={priority}
      draggable={false}
      className={cn("select-none object-contain", imageClassName)}
    />
  </div>
);

export default CaptionStyleThumbnail;
